"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserStatus = exports.KYCStatus = exports.OrganizationStatus = exports.OrganizationInvitationStatus = exports.Role = exports.AdminControllerGetUsersStatus = exports.AdminControllerGetUsersKycStatus = void 0;
// eslint-disable-next-line @typescript-eslint/no-redeclare
exports.AdminControllerGetUsersKycStatus = {
    Pending: 'Pending',
    Passed: 'Passed',
    Rejected: 'Rejected',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
exports.AdminControllerGetUsersStatus = {
    Pending: 'Pending',
    Active: 'Active',
    Suspended: 'Suspended',
    Deleted: 'Deleted',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
exports.Role = {
    OrganizationAdmin: 'OrganizationAdmin',
    OrganizationDeviceManager: 'OrganizationDeviceManager',
    OrganizationUser: 'OrganizationUser',
    Issuer: 'Issuer',
    Admin: 'Admin',
    SupportAgent: 'SupportAgent',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
exports.OrganizationInvitationStatus = {
    Pending: 'Pending',
    Rejected: 'Rejected',
    Accepted: 'Accepted',
    Viewed: 'Viewed',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
exports.OrganizationStatus = {
    Submitted: 'Submitted',
    Denied: 'Denied',
    Active: 'Active',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
exports.KYCStatus = {
    Pending: 'Pending',
    Passed: 'Passed',
    Rejected: 'Rejected',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
exports.UserStatus = {
    Pending: 'Pending',
    Active: 'Active',
    Suspended: 'Suspended',
    Deleted: 'Deleted',
};
//# sourceMappingURL=originBackendAPI.schemas.js.map